import styled from 'styled-components';
import Colors from 'library/constants/colors';
import {
  IconBase,
  SlickArrowStyles,
} from 'library/styles/icon';
import {
  ShadowElevation,
  TransitionConfig,
} from 'library/constants/styles-config';

const Icon = styled(IconBase)``;

export const OverlayImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  opacity: 0;
  background-color: rgba(${Colors.shade01Rgb}, 0.7);
  transition: opacity ${TransitionConfig};
  z-index: 15;
  height: 100%;
  width: 100%;
  max-width: 160px;
  
  i {
    color: ${Colors.shade05};

    &.icon-options-vertical {
      float: right;
      visibility: hidden;
    }
    
    &.icon-magnifier-add {
      position: absolute;
      right: -10px;
      bottom: 1px;
      color: ${Colors.shade08};
      font-size: 56px;
    }
  }
`;

export const SlickSliderContainer = styled.div`
  position: relative;
  
  .slick-slide,
  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
  }

  .slick-list {
  }

  .slick-track {
    position: relative;
  }

  .slick-slide {
    &:first-child {
      padding-left: 34px;
    }
    
    margin: 0 5px;
  }

  .slick-arrow {
    ${SlickArrowStyles};
    z-index: 100;
  }
  
  ${OverlayImage} {
    z-index: 11;
  }
`;

export const OverlayActions = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 38px;
  text-align: center;
  z-index: 10;
`;

export const EditAction = styled.span`
  display: inline-block;
  height: 100%;
  margin: 0 2px;  
  padding-top: 3px;
  background-color: ${Colors.shade06};
  border-top-left-radius: 48px;
  border-top-right-radius: 48px;
  box-shadow: ${ShadowElevation};
  color: ${Colors.shade03};
  transition: background-color ${TransitionConfig};
  cursor: pointer;
  
  ${Icon} {
    transition: none;
  }
`;

export const ActionLike = styled(EditAction)`
  ${({ active, disabled }) => {
    const styles = `${disabled ? 'cursor: not-allowed;' : ''}`;

    if (active) {
      return `${styles}
        background-color: ${Colors.success};
        color: ${Colors.shade08};
    `;
    }

    return `${styles}
        background-color: ${Colors.shade08};
        color: ${Colors.shade10};
    `;
  }}
  
`;

export const ActionDelete = styled(EditAction)`
  background-color: ${Colors.error};
  color: ${Colors.shade08};
`;

const Slide = styled.div`
  max-height: 240px;
  padding: 0 6px;
  box-sizing: border-box;
  
  ${({ isEditable }) => {
    if (isEditable) {
      return `
        
        ${OverlayImage} {
          display: none;
          max-height: 160px;
          max-width: 120px;
        }
        
        img {
          max-height: 160px;
          max-width: 120px;
          width: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      `;
    }
    return `
      height: 240px;
      width: 160px;
        
       img {
          max-height: 240px;
          width: auto;
          max-width: 160px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
    `;
  }}
`;

const ImageContainer = styled.div`
  position: relative;
  //height: auto;
  height: ${({ isEditable }) => (isEditable ? '160' : '240')}px;
  width: ${({ isEditable }) => (isEditable ? '120' : '160')}px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: ${ShadowElevation};
  
  &:hover {
    ${OverlayImage} {
      opacity: 1;
      min-height: max-content;
      height: 100%;
      width: ${({ isEditable }) => (isEditable ? '120' : '160')}px;
    }
  }
`;

export {
  Icon,
  Slide,
  ImageContainer,
};
